import React from 'react';
import { Modal } from '@/components/custom/modal/modal';
import { t } from 'i18next';
import { DashboardSummaryActionTitle, DashboardSummaryBodyCount, DashboardSummary, DashboardSummaryCount, DashboardSummaryHat, DashboardSummaryHeader } from '@/components/custom/dashboard';

export default function CreationCustomModal(props) {
  const { show, onClose, form, handleSubmit } = props;

  return (
    <Modal
      show={show}
      onClose={onClose}
      contentClassName="modal__content--md"
    >
      <h3 className="modal__simple-title">{t('textsCommon.participantDistribution')}</h3>

      <DashboardSummary
        variant="bright"
        className="mb-4"
        style={{ width: '80%' }}
      >
        <DashboardSummaryHeader>
          <DashboardSummaryHat>Projeto</DashboardSummaryHat>
          <DashboardSummaryActionTitle>{form?.values?.title}</DashboardSummaryActionTitle>
          <DashboardSummaryCount>Personalizado</DashboardSummaryCount>
        </DashboardSummaryHeader>

        <div>
          <DashboardSummaryBodyCount className="mb-2">
            {form?.values?.participants?.length} <span>{t('sideBar.participants')}</span>
          </DashboardSummaryBodyCount>
        </div>
      </DashboardSummary>

      <p className="mb-4">Você confirma a criação dos grupos para o projeto?</p>

      <div className="card__columns">
        <button
          type="button"
          className="btn btn--outline btn--full"
        >
          Não
        </button>
        <button
          type="button"
          className="btn btn--primary btn--full"
          onClick={() => handleSubmit()}
        >
          Sim
        </button>
      </div>
    </Modal>
  );
}
